module.exports = __webpack_public_path__ + "media/images/expert__dominic-ledergerber-155e2e54ca5735785adab9ee0c2253d5.png";